import React from 'react';
import QRCode from 'react-qr-code';
import PropTypes from 'prop-types';

import { staticRoutes } from '@atlas/routing';

import TerminalQrCodePopup from 'src/terminal/popups/TerminalQrCodePopup';

const TerminalBankAccountPopup = ({ id }) => {
  const link = `${window.MobileMainLink}${staticRoutes.clientProfile}/profile/account-numbers`;
  return (
    <TerminalQrCodePopup
      className="terminal-signin-modal"
      id={id}
      qrCode={<QRCode size={240} value={link} />}
      text="kyc_popup_register_bank_account_descriprion"
      title="kyc_popup_register_bank_account_title"
    />
  );
};

TerminalBankAccountPopup.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default TerminalBankAccountPopup;
